// Insurance organization logos imports
import AdvaniaPng from '../components/ui/InsuranceLogos/Advania.png';
import AllianzPng from '../components/ui/InsuranceLogos/Allianz.png';
import AlteLeipzigerPng from '../components/ui/InsuranceLogos/AlteLeipziger.png';
import AXAPng from '../components/ui/InsuranceLogos/Axa.png';
import BaloisePng from '../components/ui/InsuranceLogos/Baloise.png';
import ConcordiaPng from '../components/ui/InsuranceLogos/Concordia.png';
import CondorPng from '../components/ui/InsuranceLogos/Condor.png';
import ContinentalePng from '../components/ui/InsuranceLogos/Continentale.png';
import DialogPng from '../components/ui/InsuranceLogos/Dialog.png';
import DomcuraPng from '../components/ui/InsuranceLogos/Domcura.png';
import ErgoPng from '../components/ui/InsuranceLogos/Ergo.png';
import FeuersozietaetPng from '../components/ui/InsuranceLogos/Feuersozietaet.png';
import GeneraliPng from '../components/ui/InsuranceLogos/Generali.png';
import GothaerPng from '../components/ui/InsuranceLogos/Gothaer.png';
import GrundeigentuemerPng from '../components/ui/InsuranceLogos/Grundeigentuemer.png';
import HaftpflichtkassePng from '../components/ui/InsuranceLogos/Haftpflichtkasse.png';
import HausbesitzerPng from '../components/ui/InsuranceLogos/Hausbesitzer.png';
import HDIPng from '../components/ui/InsuranceLogos/HDI.png';
import HelvetiaPng from '../components/ui/InsuranceLogos/Helvetia.png';
import HVSPng from '../components/ui/InsuranceLogos/HVS.png';
import InterlloydPng from '../components/ui/InsuranceLogos/Interlloyd.png';
import LVMPng from '../components/ui/InsuranceLogos/Lvm.png';
import MannheimerPng from '../components/ui/InsuranceLogos/Mannheimer.png';
import NuernbergerPng from '../components/ui/InsuranceLogos/Nuernberger.png';
import OeffentlicheOldenburgPng from '../components/ui/InsuranceLogos/OeffentlicheOldenburg.png';
import OeffentlicheSachversicherungBraunschweigPng from '../components/ui/InsuranceLogos/OeffentlicheSachversicherungBraunschweig.png';
import OeffentlicheVersicherungBremenPng from '../components/ui/InsuranceLogos/OeffentlicheVersicherungBremen.png';
import ProvinzialPng from '../components/ui/InsuranceLogos/Provinzial.png';
import RheinlandVersicherungenPng from '../components/ui/InsuranceLogos/RheinlandVersicherungen.png';
import RVPng from '../components/ui/InsuranceLogos/RV.png';
import SignalIdunaPng from '../components/ui/InsuranceLogos/SignalIduna.png';
import SparkassenVersicherungPng from '../components/ui/InsuranceLogos/SparkassenVersicherung.png';
import VGHPng from '../components/ui/InsuranceLogos/VGH.png';
import WuerttembergischePng from '../components/ui/InsuranceLogos/Wuerttembergische.png';
import ZurichPng from '../components/ui/InsuranceLogos/Zurich.png';

// default google maps id, there is some styling eg. attached to this id on google side
const GOOGLE_MAPS_DEFAULT_MAP_ID = '879017f35b0b3705';

const OQIO_SUPPORT_USER_EMAIL = 'support@oqio.de';
const OQIO_CONNECT_BOT_USER_EMAIL = 'connect-bot@oqio.de';
// Interne oqio-User, die in allen Nutzerlisten der App ausgeblendet werden.
const HIDDEN_OQIO_USER_EMAILS = [OQIO_SUPPORT_USER_EMAIL, OQIO_CONNECT_BOT_USER_EMAIL];

const DEFAULT_QUERY_PARAM_CLAIM_SORT = '-updated_at_claim_and_settlements_and_messages';

const ATTACHMENT_MAX_SIZES = {
  default: {
    byte: 20 * 1024 * 1024,
    megaByte: 20
  },
  organizationDocuments: {
    byte: 100 * 1024 * 1024,
    megaByte: 100
  }
};

const MAIN_NAVIGATION_HEIGHT = 60;
const PAGE_HEADER_HEIGHT = 100;
const PAGE_BOTTOM_MARGIN_HEIGHT = 20;
const DETAILS_NAVIGATION_HEIGHT = 50;
const DETAILS_TAB_MARGIN = 20;
const BORDER_HEIGHT = 1;

const ATTACHMENT_TYPES_CLAIM_MESSAGE = [
  {
    key: 'claimPdfReport',
    label: 'Schadenakte'
  },
  {
    key: 'documents',
    label: 'Dokumente'
  },
  {
    key: 'settlements',
    label: 'Regulierung'
  },
  {
    key: 'ownFile',
    label: 'Eigene Datei'
  }
];

const ATTACHMENT_TYPES_RISK_MESSAGE = [
  {
    key: 'ownFile',
    label: 'Eigene Datei'
  }
];

const ALLOWED_FILE_TYPES = {
  default: {
    description: 'Akzeptiertes Dateiformat: PDF, JPG, JPEG, PNG',
    accept: {
      'application/pdf': ['.pdf'],
      'image/jpeg': ['.jpg', '.jpeg'],
      'image/png': ['.png']
    }
  },
  legal: {
    description: 'Akzeptiertes Dateiformat: PDF',
    accept: {
      'application/pdf': ['.pdf']
    }
  },
  image: {
    description: 'Akzeptiertes Dateiformat: JPG, JPEG, PNG',
    accept: {
      'image/png': ['.png'],
      'image/jpeg': ['.jpg', '.jpeg']
    }
  },
  organizationDocuments: {
    description: 'Akzeptiertes Dateiformat: PDF, JPG, JPEG, PNG, XLSX, MP4',
    accept: {
      'application/pdf': ['.pdf'],
      'image/png': ['.png'],
      'image/jpeg': ['.jpg', '.jpeg'],
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
      'video/mp4': ['.mp4']
    }
  }
};

const MENU_ITEMS = [
  {
    key: 'claims',
    label: 'Schäden',
    link: '/claims/list',
    mainPathRoot: '/claims',
    detailsPathRoot: '/claim'
  },
  {
    key: 'risks',
    label: 'Risiken',
    link: '/risks/list',
    mainPathRoot: '/risks',
    detailsPathRoot: '/risk',
    accessRights: ['risks_ui']
  },
  {
    key: 'policies',
    label: 'Verträge',
    link: '/policies/list',
    mainPathRoot: '/policies',
    detailsPathRoot: '/policy',
    accessRights: ['policies_ui']
  },
  {
    key: 'reporting',
    label: 'Reporting',
    link: '/reporting/claims',
    mainPathRoot: '/reporting',
    accessRights: ['reporting_ui'],
    hideOnMobile: true
  },
  {
    key: 'generalMessages',
    label: 'Disposition',
    link: '/general-messages',
    mainPathRoot: '/general-messages',
    accessRights: ['general_worklist_ui'],
    hideOnMobile: true
  }
];

const REPORTING_MENU_ITEMS = [
  {
    label: 'Schäden',
    path: 'claims',
    accessRights: ['reporting_claims_and_settlements_ui']
  },
  {
    label: 'Rechnungen',
    path: 'settlements',
    accessRights: ['reporting_claims_and_settlements_ui']
  },
  {
    label: 'Auffällige Risiken',
    path: 'risk-outliers',
    accessRights: ['reporting_risk_outliers_ui']
  },
  {
    label: 'Rentabilität',
    path: 'profitability',
    accessRights: ['reporting_profitability_ui']
  }
];

const CLAIM_DEFAULT_INSURED_RISK_TYPE = 'default';

const CLAIM_DETAILS_MENU_ITEMS = [
  {
    label: 'Übersicht',
    key: 'main',
    insuredRiskType: [CLAIM_DEFAULT_INSURED_RISK_TYPE, 'building', 'glass', 'construction', 'liability']
  },
  {
    label: 'Anspruchsteller',
    key: 'claimants',
    insuredRiskType: ['liability']
  },
  {
    label: 'Verursacher',
    key: 'causer',
    insuredRiskType: [CLAIM_DEFAULT_INSURED_RISK_TYPE, 'building', 'glass', 'construction']
  },
  {
    label: 'Geschädigte',
    key: 'damaged_units',
    insuredRiskType: [CLAIM_DEFAULT_INSURED_RISK_TYPE, 'building', 'glass', 'construction']
  },
  {
    label: 'Dokumente',
    key: 'documents',
    insuredRiskType: [CLAIM_DEFAULT_INSURED_RISK_TYPE, 'building', 'glass', 'construction', 'liability']
  },
  {
    label: 'Regulierung',
    key: 'settlements',
    insuredRiskType: [CLAIM_DEFAULT_INSURED_RISK_TYPE, 'building', 'glass', 'construction', 'liability']
  },
  {
    label: 'Beteiligte',
    key: 'participants',
    insuredRiskType: [CLAIM_DEFAULT_INSURED_RISK_TYPE, 'building', 'glass', 'construction', 'liability']
  },
  {
    label: 'Verlauf',
    key: 'history',
    insuredRiskType: [CLAIM_DEFAULT_INSURED_RISK_TYPE, 'building', 'glass', 'construction', 'liability']
  }
];

const POLICY_DETAILS_MENU_ITEMS = [
  {
    label: 'Übersicht',
    key: 'main',
    value: 'main'
  },
  {
    label: 'Gefahren',
    key: 'insured-risks',
    value: 'insured-risks'
  },
  {
    label: 'Dokumente',
    key: 'documents',
    value: 'documents'
  },
  {
    label: 'Beiträge',
    key: 'premiums',
    value: 'premiums'
  },
  {
    label: 'Risiken',
    key: 'risks',
    value: 'risks'
  },
  {
    label: 'Schäden',
    key: 'claims',
    value: 'claims'
  }
];

const RISK_DETAILS_MENU_ITEMS = [
  {
    label: 'Übersicht',
    key: 'main',
    value: 'main'
  },
  {
    label: 'Einheiten',
    key: 'risk-units',
    value: 'risk-units'
  },
  {
    label: 'Unternehmen',
    key: 'organizations',
    value: 'organizations'
  },
  {
    label: 'Verträge',
    key: 'policies',
    value: 'policies'
  },
  {
    label: 'Schäden',
    key: 'claims',
    value: 'claims'
  }
];

const CLAIM_STATUSES = [
  {
    value: 'open',
    label: 'Offen',
    icon: 'open'
  },
  {
    value: 'closed',
    label: 'Geschlossen',
    icon: 'closed'
  },
  {
    value: 'rejected',
    label: 'Abgelehnt / Storniert',
    icon: 'rejected'
  }
];

const CLAIMS_VIEW_OPTIONS = [
  {
    value: 'list',
    label: 'Liste'
  },
  {
    value: 'map',
    label: 'Karte'
  }
];

const CLAIMS_SORT_OPTIONS = [
  {
    label: 'Zuletzt geändert',
    value: '-updated_at_claim_and_settlements_and_messages'
  },
  {
    label: 'Erstellungsdatum',
    value: '-created_at'
  },
  {
    label: 'Schadentag',
    value: '-date_of_damage'
  }
];

const POLICIES_SORT_OPTIONS = [
  {
    label: 'Versicherer',
    value: 'insurance_org'
  },
  {
    label: 'Anzahl der Risiken',
    value: '-risk_count'
  },
  {
    label: 'Zuletzt geändert',
    value: '-updated_at_policy_and_relations'
  }
];

const SETTLEMENT_STATUSES = [
  {
    value: 'open',
    label: 'Offen'
  },
  {
    value: 'closed',
    label: 'Geschlossen'
  },
  {
    value: 'rejected',
    label: 'Abgelehnt'
  }
];

const SETTLEMENT_REGULATION_FIELD_KEYS = ['settled_amount', 'cutbacks', 'report', 'settled_at'];

const SETTLEMENT_TYPE_INVOICE = 'invoice';
const SETTLEMENT_TYPE_QUOTATION = 'quotation';

const CAUSER_TYPES = [
  {
    value: 'no_causer',
    label: 'Kein Verursacher'
  },
  {
    value: 'tenant',
    label: 'Mieter'
  },
  {
    value: 'contractor',
    label: 'Fremdfirma'
  },
  {
    value: 'policyholder',
    label: 'Versicherungnehmer'
  },
  {
    value: 'unknown',
    label: 'Unbekannt'
  }
];

const DAMAGED_UNITS_STANDARD_AUTOCOMPLETE_OPTIONS = [
  'Dachgeschoss (allgemeiner Gebrauch)',
  'Kellergeschoss (allgemeiner Gebrauch)',
  'Sonstiges (s. Notizen)'
];

const INSURANCE_STATUSES = [
  {
    value: 'has_insurance',
    label: 'Vorhanden'
  },
  {
    value: 'has_no_insurance',
    label: 'Nicht vorhanden'
  },
  {
    value: 'information_refused',
    label: 'Auskunft verweigert'
  }
];

const LIABILITY_INSURANCE_STATUSES = [
  {
    value: 'has_liability_insurance',
    label: 'Vorhanden'
  },
  {
    value: 'has_no_liability_insurance',
    label: 'Nicht vorhanden'
  },
  {
    value: 'information_refused',
    label: 'Auskunft verweigert'
  }
];

const CLAIMANT_RELATION_TO_POLICYHOLDER = [
  {
    value: 'tenancy',
    label: 'Mietverhältnis'
  },
  {
    value: 'employment',
    label: 'Arbeitsverhältnis'
  },
  {
    value: 'kinship',
    label: 'Verwandtschaft'
  },
  {
    value: 'none',
    label: 'Keines'
  }
];

const CLAIM_LIABILITY_DAMAGE_TO_TYPES = [
  {
    value: 'person',
    label: 'Personenschaden'
  },
  {
    value: 'property',
    label: 'Sachschaden'
  },
  {
    value: 'personAndProperty',
    label: 'Personen- und Sachschaden'
  }
];

const IMPORT_TEMPLATE_HEADERS_GROUPS = [
  {
    value: 'Risk',
    label: 'Risikodaten'
  },
  {
    value: 'Policy',
    label: 'Vertragsdaten'
  }
];

const ORGANIZATIONS_TYPES = [
  {
    id: 0,
    label: 'Portalbetreiber',
    value: 'licensee',
    canBeCreated: false,
    availableRoles: [
      { id: 0, text: 'Admin', value: 'admin' },
      { id: 1, text: 'Sachbearbeiter', value: 'clerk' },
      { id: 2, text: 'Manager', value: 'manager' }
    ]
  },
  {
    id: 1,
    label: 'Versicherung',
    value: 'insurance',
    canBeCreated: true,
    availableRoles: [
      { id: 0, text: 'Sachbearbeiter', value: 'clerk' },
      { id: 1, text: 'Manager', value: 'manager' }
    ]
  },
  {
    id: 2,
    label: 'Schadenservice',
    value: 'insurance_broker',
    canBeCreated: true,
    availableRoles: [
      { id: 0, text: 'Sachbearbeiter', value: 'clerk' },
      { id: 1, text: 'Manager', value: 'manager' }
    ]
  },
  {
    id: 3,
    label: 'Immobilienverwaltung',
    value: 'housing_company',
    canBeCreated: true,
    availableRoles: [
      { id: 0, text: 'Sachbearbeiter', value: 'clerk' },
      { id: 1, text: 'Manager', value: 'manager' }
    ]
  },
  {
    id: 4,
    label: 'Reparaturdienstleister',
    value: 'service_provider',
    canBeCreated: true,
    availableRoles: [
      { id: 0, text: 'Sachbearbeiter', value: 'clerk' },
      { id: 1, text: 'Manager', value: 'manager' }
    ]
  }
];

// These are the containers that are always shown in the file container list:
// Images of the damage (Bilder zum Schadensausmaß), Other documents (Sonstige Dokumente)
const DEFAULT_FILE_CONTAINER_IDS = ['b5d1f89c-9cbc-44db-973e-5a7307571853', 'd9e22196-68c8-43da-b343-801416650921'];

const ERROR_TYPES = {
  ERROR_TECHNICAL_PROBLEM: {
    type: 'technicalProblem',
    headline: 'Leider gab es ein technisches Problem',
    message: 'Sollte der Fehler wiederholt auftreten, wenden Sie sich bitte an support@oqio.de.'
  },
  ERROR_NOT_AUTHORIZED: {
    type: 'notAuthorized',
    headline: 'Fehlende Berechtigung',
    message: 'Sie sind nicht berechtigt, auf diese Seite zuzugreifen.'
  },
  ERROR_PAGE_NOT_FOUND: {
    type: 'notFound',
    headline: 'Seite nicht gefunden',
    message: 'Die Seite, die Sie suchen, wurde nicht gefunden.'
  }
};

const IMPORT_TABLE_ROW_STATUSES = {
  new: {
    label: 'Neu',
    color: 'var(--primary-oqio-green)'
  },
  invalid: {
    label: 'Ungültig',
    color: 'var(--primary-oqio-red)'
  },
  no_changes: {
    label: 'Unverändert',
    color: 'var(--greyscale-shade)'
  },
  updated: {
    label: 'Aktualisiert',
    color: 'var(--primary-oqio-blue)'
  }
};

const IMPORT_SUMMARY_ROWS = [
  {
    key: 'new_risk_count',
    entityNameSingular: 'Risiko',
    entityNamePlural: 'Risiken',
    operation: 'erstellt'
  },
  {
    key: 'new_policy_count',
    entityNameSingular: 'Vertrag',
    entityNamePlural: 'Verträge',
    operation: 'erstellt'
  },
  {
    key: 'updated_risk_count',
    entityNameSingular: 'Risiko',
    entityNamePlural: 'Risiken',
    operation: 'aktualisiert'
  },
  {
    key: 'updated_policy_count',
    entityNameSingular: 'Vertrag',
    entityNamePlural: 'Verträge',
    operation: 'aktualisiert'
  },
  {
    key: 'new_policy_to_risk_count',
    entityNameSingular: 'Vertrag',
    entityNamePlural: 'Verträge',
    operation: 'zugeordnet'
  }
];

// Keys mirror SYMBOLS in SchemaGroupIcon.js — keep both in sync.
// The slug keys are car damage types - placeholder for uuids from backend
const CLAIM_TYPE_FILTER_LABLE_COLORS = {
  'unfallschaden-am-eigenen-kfz': 'var(--damage-type-accident)', // 'accident',
  tiere: 'var(--damage-type-animal)', // 'animal',
  'f1f28d6e-9e26-4171-b345-0d702c137d51': 'var(--damage-type-breakage)', // 'breakage',
  '49504569-2b24-421c-b645-d7bbb38912b0': 'var(--damage-type-breakage)', // 'breakage',
  glasbruch: 'var(--damage-type-breakage)', // 'breakage',
  'dfbee8a1-0fcf-48a7-8dfa-18a83a5aa34b': 'var(--damage-type-building)', // 'building',
  '4dc7e85c-84f0-4e3f-ae21-644062316411': 'var(--damage-type-elemental)', // 'elemental',
  'cc1e6337-2eb8-409b-b7bc-704a8aa8d3a4': 'var(--damage-type-fire)', // 'fire',
  feuer: 'var(--damage-type-fire)', // 'fire',
  'unfallschaden-an-dritten': 'var(--damage-type-liability)', // 'liabilityAccident',
  '11672aae-9566-4431-9864-6b70cda90b56': 'var(--damage-type-liability)', // 'liabilityConstruction',
  '35bb4466-02ee-461f-a35e-c05285bec3df': 'var(--damage-type-liability)', // 'liabilityFacility',
  '19ca53e6-6d98-403e-9549-0d98a0b4eb22': 'var(--damage-type-liability)', // 'liabilityProperty',
  '2d5907c7-a6cd-4558-856f-08d754816464': 'var(--damage-type-liability)', // 'liabilityWater',
  '51126254-8016-4e52-9ce1-3c1995d91852': 'var(--damage-type-other)', // 'other',
  '4010e99c-fd07-4f87-acfc-6e3b7dd7dd88': 'var(--damage-type-storm)', // 'storm',
  unwetter: 'var(--damage-type-storm)', // 'storm',
  diebstahl: 'var(--damage-type-theft)', // 'theft',
  'f7c11fda-2c9e-4036-9637-557370dd4c7c': 'var(--damage-type-vandalism)', // 'vandalism',
  vandalismus: 'var(--damage-type-vandalism)', // 'vandalism',
  '17236d3c-3daa-43a2-8048-9b5f571ec480': 'var(--damage-type-water)' // 'water',
};

const FILTER_COUNT_SLIDER_MARKS = {
  1: '1',
  2: '2',
  3: '3',
  4: '4',
  5: '5',
  6: '6',
  7: '7',
  8: '8',
  9: '9',
  10: '10',
  11: '20',
  12: '30',
  13: '40',
  14: '50',
  15: '100'
};

const RISK_EXTERNAL_ORIGIN_FIELDS = ['street', 'zipcode', 'town', 'external_id', 'housing_stock'];

const MAX_REMINDER_MESSAGE_LENGTH = 240;

const NON_INSURED_COSTS = 'Grund der Differenz';
const DIFFERENCE = 'Differenz';
const NO_RISK_SELECTED_TITLE = 'Keine Gefahr ausgewählt';

const INFORMATION_BANNER_TEXT =
  'Einige Daten stammen aus einer externen Software. Diese können Sie nur dort bearbeiten.';

const INSURED_RISK_ADDENDUM_REGEXP = new RegExp(/^[^()]*$/);

// This variable is used to determine the height of the import table body.
// The 268px are the sum of the navigation(60px), the page header (100px), the table columns headers (41px),
// the checkboxes (45px), the 20px bottom margin and the 2px border.
const HEIGHT_OF_COMPONENTS_OUTSIDE_IMPORT_TABLE_BODY = 268;

// here are the logos of the insurance organizations
// the key is the name of the organization and the same like in the INSURANCE_ORGANIZATIONS
const INSURANCE_ORGANIZATIONS_LOGOS = {
  Advania: AdvaniaPng,
  Allianz: AllianzPng,
  AlteLeipziger: AlteLeipzigerPng,
  AXA: AXAPng,
  Baloise: BaloisePng,
  Concordia: ConcordiaPng,
  Condor: CondorPng,
  Continentale: ContinentalePng,
  Dialog: DialogPng,
  Domcura: DomcuraPng,
  Ergo: ErgoPng,
  Feuersozietaet: FeuersozietaetPng,
  Generali: GeneraliPng,
  Gothaer: GothaerPng,
  Grundeigentuemer: GrundeigentuemerPng,
  Haftpflichtkasse: HaftpflichtkassePng,
  Hausbesitzer: HausbesitzerPng,
  HDI: HDIPng,
  Helvetia: HelvetiaPng,
  HVS: HVSPng,
  Interlloyd: InterlloydPng,
  LVM: LVMPng,
  Mannheimer: MannheimerPng,
  Nuernberger: NuernbergerPng,
  OeffentlicheOldenburg: OeffentlicheOldenburgPng,
  OeffentlicheSachversicherungBraunschweig: OeffentlicheSachversicherungBraunschweigPng,
  OeffentlicheVersicherungBremen: OeffentlicheVersicherungBremenPng,
  Provinzial: ProvinzialPng,
  RheinlandVersicherungen: RheinlandVersicherungenPng,
  RV: RVPng,
  SignalIduna: SignalIdunaPng,
  SparkassenVersicherung: SparkassenVersicherungPng,
  VGH: VGHPng,
  Wuerttembergische: WuerttembergischePng,
  Zurich: ZurichPng
};

// here are the insurance organizations with their different names
// the key is the name of the organization and the same like in the INSURANCE_ORGANIZATIONS_LOGOS
const INSURANCE_ORGANIZATIONS = {
  Advania: ['Advania', 'Advania Versicherung', 'Advania Falko Kortylak'], // Advania GmbH
  Allianz: [
    'Allianz',
    'Allianz Versicherung',
    'Allianz Sachschaden',
    'Allianz Versicherungs AG',
    'Allianz Versicherungs-AG', // Offizielle Schreibweise
    'Allianz Esa GmbH' // Allianz-Esa
  ], // Allianz
  AlteLeipziger: ['Alte Leipziger', 'Alte Leipziger Versicherung'], // Alte Leipziger
  AXA: ['AXA', 'AXA Versicherung', 'AXA Versicherung AG'], // AXA
  Baloise: ['Baloise', 'Baloise Versicherung', 'Baloise Sachversicherung AG'], // Baloise
  Concordia: ['Concordia', 'Concordia Versicherung', 'Concordia Versicherungs-Gesellschaft auf Gegenseitigkeit'], // Concordia
  Condor: ['Condor', 'Condor Versicherungen', 'Condor Allgemeine Versicherungs-AG'], // Condor
  Continentale: ['Continentale', 'Continentale Versicherung', 'Die Continentale'], // Continentale
  Dialog: ['Dialog', 'Dialog Versicherung', 'Dialog Versicherung AG'], // Dialog
  Domcura: ['Domcura', 'Domcura Versicherung'], // Domcura
  Ergo: ['Ergo', 'Ergo Versicherung', 'Ergo Versicherung AG'], // Ergo
  Feuersozietaet: ['Feuersozietät'], // Feuersozietät
  Generali: ['Generali', 'Generali Versicherung', 'Generali Deutschland Versicherung AG'], // Generali
  Gothaer: ['Gothaer', 'Gothaer Versicherungen', 'Gothaer Allgemeine Versicherung'], // Gothaer
  Grundeigentuemer: [
    'Grundeigentümer',
    'Grundeigentümer Versicherung',
    'Grundeigentümer-Versicherung',
    'Grundeigentümerversicherung',
    'GEV'
  ], // GEV
  Haftpflichtkasse: ['Haftpflichtkasse', 'Die Haftpflichtkasse'], // Haftpflichtkasse
  Hausbesitzer: ['Hausbesitzer', 'Hausbesitzer Versicherung', 'Hausbesitzer-Versicherung', 'bhvg'], // Hausbesitzer Versicherung
  HDI: ['HDI', 'HDI Versicherung', 'HDI Global SE', 'HDI Versicherung AG'], // HDI
  Helvetia: ['Helvetia', 'Helvetia Versicherung', 'Helvetia Schweizerische Versicherungsgesellschaft'], // Helvetia
  HVS: ['HVS', 'HVS Versicherung', 'HVS AG'], // HVS AG
  Interlloyd: ['Interlloyd', 'Interlloyd Versicherungen'], // Interlloyd
  LVM: ['LVM', 'LVM Landwirtschaftlicher Versicherungsverein Münster a.G.'], // LVM
  Mannheimer: ['Mannheimer', 'Mannheimer Versicherung', 'Mannheimer Versicherung AG'], // Mannheimer
  Nuernberger: [
    'Nürnberger',
    'Nuernberger',
    'Nürnberger Versicherung',
    'Nuernberger Versicherung',
    'NÜRNBERGER Allgemeine Versicherung'
  ], // Nürnberger
  OeffentlicheOldenburg: ['Öffentliche Oldenburg'], // Öffentliche Oldenburg
  OeffentlicheSachversicherungBraunschweig: [
    'Öffentliche Sachversicherung Braunschweig',
    'Öffentliche Versicherung Braunschweig'
  ], // Öffentliche Braunschweig'
  OeffentlicheVersicherungBremen: ['ÖVB', 'ÖVB Versicherung'], // ÖVB
  Provinzial: [
    'Provinzial',
    'Provinzial Versicherung',
    'Provinzial Nord Brandkasse Aktiengesellschaft',
    'Provinzial Versicherung AG'
  ], // Provinzial
  RheinlandVersicherungen: ['RheinLand Versicherungen'], // RheinLand
  RV: ['R+V', 'R + V', 'R+V Versicherung', 'R+V Allgemeine Versicherung AG'], // R+V
  SignalIduna: ['Signal Iduna', 'Signal Iduna Versicherung'], // Signal Iduna'
  SparkassenVersicherung: ['Sparkassen Versicherung', 'SV Sparkassen-Versicherung'], // SV Sparkassen Versicherung
  VGH: ['VGH', 'VGH Versicherung', 'Landschaftliche Brandkasse Hannover (VGH)'], // VGH
  Wuerttembergische: [
    'Württembergische',
    'Wuerttembergische',
    'Württembergische Versicherung',
    'Wuerttembergische Versicherung',
    'Württembergische Vers. AG'
  ], // Württembergische
  Zurich: ['Zurich', 'Zurich Versicherung', 'Zurich Insurance plc'] // Zurich
};

const RECOMMENDATION_TYPES = {
  ADD_MISSING_CLAIM_DATA: 'add_missing_claim_data_insured_risk_or_policy',
  CREATE_CLAIM_VIA_BIPRO: 'create_claim_at_insurance_via_bipro',
  CREATE_CLAIM_VIA_MESSAGE: 'create_claim_at_insurance_via_message',
  SEND_SETTLEMENT_TO_INSURANCE_API: 'send_settlement_to_insurance_via_bipro',
  SEND_SETTLEMENT_TO_PROPERTY_EXPERT: 'send_settlement_to_property_expert',
  UPDATE_CLAIM_VIA_BIPRO: 'update_claim_at_insurance_via_bipro',
  UPDATE_CLAIM_VIA_MESSAGE: 'update_claim_at_insurance_via_message'
};

const REDUX_ASYNC_STATUSES = {
  IDLE: 'idle',
  LOADING: 'loading',
  SUCCEEDED: 'succeeded',
  FAILED: 'failed'
};

const ONBOARDING_STEPS = {
  INITIAL: 'initial', // DB is set to this value for new licensees

  OVERVIEW_ORGANIZATION: 'overview_organization',
  ORG_CREATE: 'org_create',
  ORG_EDIT: 'org_edit',
  APPEARANCE: 'appearance',
  USERS: 'users',
  DOCUMENTS: 'documents',
  ORG_SUCCESS: 'org_success',

  OVERVIEW_HOUSING_STOCK: 'overview_housing_stock',
  HOUSING_STOCK: 'housing_stock',
  PARTNERS: 'partners',
  NOTIFICATIONS: 'notifications',
  DATA_SOURCE_SELECT: 'data_source_select',
  IMPORT_UPLOAD: 'import_upload',
  API_INFO: 'api_info',
  PARTNER_USERS: 'partner_users',
  HOUSING_STOCK_SUCCESS: 'housing_stock_success',

  COMPLETED: 'completed' // User is now able to use the application, onboarding is completed
};

const ONBOARDING_SOURCE_TYPES = {
  IMPORT: 'import',
  API: 'api'
};

const ADMINISTRATION_SIDEBAR_ITEMS = {
  myOrganization: {
    key: 'my-organization',
    label: 'Mein Unternehmen',
    path: '/administration/my-organization/profile',
    icon: 'myOrganization',
    accessRights: 'administration_ui'
  },
  organizations: [
    {
      key: 'insurance',
      label: 'Versicherung',
      path: '/administration/organizations/insurance',
      icon: 'shield',
      accessRights: 'administration_organizations_ui'
    },
    {
      key: 'insurance_broker',
      label: 'Schadenservice',
      path: '/administration/organizations/insurance_broker',
      icon: 'broker',
      accessRights: 'administration_organizations_ui'
    },
    {
      key: 'housing_company',
      label: 'Immobilienwirtschaft',
      path: '/administration/organizations/housing_company',
      icon: 'house',
      accessRights: 'administration_organizations_ui'
    },
    {
      key: 'service_provider',
      label: 'Reparaturdienstleister',
      path: '/administration/organizations/service_provider',
      icon: 'wrench',
      accessRights: 'administration_organizations_ui'
    }
  ],
  housingStocks: {
    key: 'housing-stocks',
    label: 'Meine Bestände',
    path: '/administration/housing-stocks',
    icon: 'housingStocks',
    accessRights: 'administration_housing_stocks_ui'
  },
  masterData: {
    key: 'master-data',
    label: 'Stammdaten',
    path: '/administration/master-data',
    icon: 'masterData',
    accessRights: 'administration_import_ui'
  },
  settings: {
    key: 'settings',
    label: 'Einstellungen',
    path: '/administration/settings/branding',
    icon: 'sliders',
    accessRights: 'administration_settings_ui'
  }
};

const ADMINISTRATION_MY_ORGANIZATION_TABS = [
  { key: 'profile', label: 'Profil' },
  { key: 'users', label: 'Nutzer' },
  { key: 'external-contacts', label: 'Externe Kontakte', accessRight: 'administration_external_contacts_ui' },
  { key: 'templates', label: 'Vorlagen' },
  { key: 'downloads', label: 'Downloads' }
];

const ADMINISTRATION_SETTINGS_TABS = [
  { key: 'branding', label: 'Markenanpassung' },
  { key: 'legal', label: 'Rechtliches' },
  { key: 'advanced', label: 'Erweitert' }
];

const ADMINISTRATION_ORGANIZATION_DETAIL_TABS = [
  { key: 'profile', label: 'Profil' },
  { key: 'users', label: 'Nutzer' },
  { key: 'templates', label: 'Vorlagen' },
  { key: 'downloads', label: 'Downloads' }
];

const ADMINISTRATION_HELP_LINKS = {
  rolesAndPermissions:
    'https://help.oqio.de/de/articles/13634593-rollen-und-rechtemanagement?utm_source=administration&utm_medium=inproduct',
  masterDataImport:
    'https://help.oqio.de/de/articles/13611115-erster-stammdaten-import?utm_source=administration&utm_medium=inproduct',
  notifications: 'https://help.oqio.de/de/articles/13645635-faq?utm_source=administration&utm_medium=inproduct'
};

// Organization notification flags persisted on the organization (new states / new messages × worklist / email).
const ORGANIZATION_NOTIFICATION_KEYS = [
  'new_states_worklist_notification',
  'new_states_email_notification',
  'new_messages_worklist_notification',
  'new_messages_email_notification'
];

const RISK_UNITS_MAX_LENGTH = 100;

const ALLOWED_SESSION_TYPES = { PASSWORD: 'oqio_password', MICROSOFT: 'microsoft' };

export {
  GOOGLE_MAPS_DEFAULT_MAP_ID,
  HIDDEN_OQIO_USER_EMAILS,
  REPORTING_MENU_ITEMS,
  ALLOWED_FILE_TYPES,
  ATTACHMENT_MAX_SIZES,
  ATTACHMENT_TYPES_CLAIM_MESSAGE,
  ATTACHMENT_TYPES_RISK_MESSAGE,
  CAUSER_TYPES,
  CLAIM_DEFAULT_INSURED_RISK_TYPE,
  CLAIM_DETAILS_MENU_ITEMS,
  POLICY_DETAILS_MENU_ITEMS,
  RISK_DETAILS_MENU_ITEMS,
  CLAIM_LIABILITY_DAMAGE_TO_TYPES,
  CLAIMANT_RELATION_TO_POLICYHOLDER,
  CLAIM_STATUSES,
  CLAIMS_VIEW_OPTIONS,
  CLAIMS_SORT_OPTIONS,
  CLAIM_TYPE_FILTER_LABLE_COLORS,
  POLICIES_SORT_OPTIONS,
  INSURANCE_STATUSES,
  DEFAULT_QUERY_PARAM_CLAIM_SORT,
  LIABILITY_INSURANCE_STATUSES,
  MENU_ITEMS,
  MAIN_NAVIGATION_HEIGHT,
  PAGE_HEADER_HEIGHT,
  PAGE_BOTTOM_MARGIN_HEIGHT,
  DETAILS_NAVIGATION_HEIGHT,
  DETAILS_TAB_MARGIN,
  BORDER_HEIGHT,
  ORGANIZATIONS_TYPES,
  SETTLEMENT_STATUSES,
  SETTLEMENT_REGULATION_FIELD_KEYS,
  SETTLEMENT_TYPE_INVOICE,
  SETTLEMENT_TYPE_QUOTATION,
  DEFAULT_FILE_CONTAINER_IDS,
  RISK_EXTERNAL_ORIGIN_FIELDS,
  MAX_REMINDER_MESSAGE_LENGTH,
  NON_INSURED_COSTS,
  DIFFERENCE,
  NO_RISK_SELECTED_TITLE,
  INFORMATION_BANNER_TEXT,
  ERROR_TYPES,
  IMPORT_TABLE_ROW_STATUSES,
  FILTER_COUNT_SLIDER_MARKS,
  INSURANCE_ORGANIZATIONS_LOGOS,
  INSURANCE_ORGANIZATIONS,
  IMPORT_SUMMARY_ROWS,
  IMPORT_TEMPLATE_HEADERS_GROUPS,
  INSURED_RISK_ADDENDUM_REGEXP,
  HEIGHT_OF_COMPONENTS_OUTSIDE_IMPORT_TABLE_BODY,
  RECOMMENDATION_TYPES,
  REDUX_ASYNC_STATUSES,
  DAMAGED_UNITS_STANDARD_AUTOCOMPLETE_OPTIONS,
  RISK_UNITS_MAX_LENGTH,
  ALLOWED_SESSION_TYPES,
  ONBOARDING_STEPS,
  ONBOARDING_SOURCE_TYPES,
  ADMINISTRATION_SIDEBAR_ITEMS,
  ADMINISTRATION_MY_ORGANIZATION_TABS,
  ADMINISTRATION_SETTINGS_TABS,
  ADMINISTRATION_ORGANIZATION_DETAIL_TABS,
  ADMINISTRATION_HELP_LINKS,
  ORGANIZATION_NOTIFICATION_KEYS
};
